export default class AbstractJourney {
  static STANDARD = 1
  static ROUND = 2
  static SHUTTLE = 3

  static _STOPPED_VEHICLES = 0
  static _STANDARD_MONO = 1
  static _STANDARD_MULTI = 2
  static _ROUND = 3
  static _STANDARD_EMPTY = 4
  static _SHUTTLE = 5
  static _ROUND_OR_SHUTTLE_EMPTY = 6
  static _ROUND_AND_SHUTTLE = 7 // Unsed

  constructor() {}
}
